import { HttpService } from './base.service'

class RouterService extends HttpService {
  private readonly prefix = 'routers'
  createrouter = (data: any) => this.post(`${this.prefix}`, data)
  getallrouters = () => this.get(`${this.prefix}/`)
}

export const routerService = new RouterService()
